import InterventionEventTokenModel from 'Models/intervention/InterventionEventTokenModel';
import { EventSourcePolyfill }     from 'event-source-polyfill';
import moment                      from 'moment';
import { appStore }                from 'stores';
import ConfigProxy                 from 'tools/ConfigProxy';

export type mercureEvent = { data: string, type: string };

export type onMessageFunction = (data: string | object, e: mercureEvent) => void;

export default class MercureInterventionPartitionListener {
	private _authTimeout?: ReturnType<typeof setTimeout>;
	private _eventSource: EventSourcePolyfill;

	private readonly _executeMessageFunction: onMessageFunction;

	private readonly _messageQueue: mercureEvent[];

	private _messageQueueIsPaused: boolean;

	private _token = new InterventionEventTokenModel();

	public constructor(onMessage: onMessageFunction) {
		this._executeMessageFunction = onMessage;

		this._messageQueue = [];
		this._messageQueueIsPaused = false;
	}

	public pauseMessageQueue(): this {
		this._messageQueueIsPaused = true;

		return this;
	}

	public resumeMessageQueue(): this {
		this._messageQueue.forEach(e => this._executeMessageFunction(JSON.parse(e.data), e));

		this._messageQueueIsPaused = false;

		return this;
	}

	public async start(topics: string[] = []): Promise<void> {
		this.stop();

		await this._fetchToken();

		const url = new URL(ConfigProxy.getServiceConfig('mercure', 'api_endpoint') || '');

		if (topics.length) {
			topics.forEach(topic => url.searchParams.append('topic', topic));
		}

		this._eventSource = new EventSourcePolyfill(url.toString().replace('/?', '?'), {
			headers: { 'Authorization': `Bearer ${this._token.jwt}` },
		});

		this._eventSource.onmessage = this._onMessage;
	}

	public stop(): void {
		if (this._eventSource) {
			this._eventSource.close();
		}

		if (this._authTimeout) {
			clearTimeout(this._authTimeout);
		}
	}

	private async _fetchToken() {
		await this._token.clear().patch({ subPartitionUrn: appStore.subPartitionUrn });

		const timeRemaining = this._token.expMoment.diff(moment(), 'second');

		this._authTimeout = setTimeout(this._fetchToken.bind(this), timeRemaining * 1000);
	}

	private _onMessage = (e: mercureEvent): void => {
		// console.info('Mercure event received', e);

		if (this._messageQueueIsPaused) {
			this._messageQueue.push(e);
		}

		this._executeMessageFunction(e.data, e);
	};
}